module.exports = __webpack_public_path__ + "static/media/product.db2ee48b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/product.svg
// module id = 165
// module chunks = 6